import clientsTypes from "./clientsTypes";
import clientsApi from "./clientsApi";
import { Roles } from "../../config";

const clientsActions = {
    getClients: (id, params, searchRef = null) => dispatch => {
        dispatch({
            type: clientsTypes.GET_CLIENTS_PENDING
        })
        const {
            roles: _roles,
            groupId: _groupId,
            branch_ids: _branchIds,
            city_ids: _cityIds,
            token,
            ...otherParams
        } = params

        clientsApi.getClients(id, otherParams, token)
          .then(res => {
              dispatch({
                  type: clientsTypes.GET_CLIENTS_SUCCESS,
                  payload: res.data
              })
          })
          .catch(() => {
              dispatch({
                  type: clientsTypes.GET_CLIENTS_ERROR
              })
          })
          .finally(() => searchRef && searchRef.current && searchRef.current.focus())
    },
    getClientsDatabase: (id, params, searchRef = null) => dispatch => {
        dispatch({
            type: clientsTypes.GET_CLIENTS_PENDING
        })
      const {
        currentRole,
        groupId = '',
        ...otherParams
      } = params

        if (currentRole === Roles.ADMINISTRATOR && groupId) {
            clientsApi.getAnalyticClientsDatabase(groupId, otherParams)
              .then(res => {
                  dispatch({
                      type: clientsTypes.GET_CLIENTS_SUCCESS,
                      payload: res.data
                  })
              })
              .catch(() => {
                  dispatch({
                      type: clientsTypes.GET_CLIENTS_ERROR
                  })
              })
              .finally(() => searchRef && searchRef.current && searchRef.current.focus())
        } else {
            clientsApi.getClientsDatabase(id, otherParams)
              .then(res => {
                  dispatch({
                      type: clientsTypes.GET_CLIENTS_SUCCESS,
                      payload: res.data
                  })
              })
              .catch(() => {
                  dispatch({
                      type: clientsTypes.GET_CLIENTS_ERROR
                  })
              })
              .finally(() => searchRef && searchRef.current && searchRef.current.focus())
        }

    },
    changeParams:(params) => {
        return {
            type:clientsTypes.CHANGE_PARAMS,
            payload: params,
        }
    },

    changeChosenClients: (c) => {
        const customer = Object.assign(c);
        customer.checked = !c.checked;

        return {
            type: clientsTypes.CHANGE_CHOSEN_CLIENTS,
            payload: customer
        }
    },

    clearChosenClients: () => ({ type: clientsTypes.CLEAR_CHOSEN_CLIENTS }),
    clearClients: () => ({ type: clientsTypes.CLEAR_CLIENTS }),
}

export default clientsActions
